import React from 'react'
import SharedCasinoStudios from '../../../shared/CasinoStudios'

/**
 * SuperAdmin wrapper for the shared CasinoStudios component
 * @returns {JSX.Element} - Rendered component
 */
const SuperAdminCasinoStudios = () => {
  return <SharedCasinoStudios isTenant={false} />
}

export default SuperAdminCasinoStudios
